import { Button } from '@mui/material';
import images from 'assets/img';
import HeaderComponent from 'components/HeaderComponent';
import React, { useContext } from 'react'
import { withTranslation } from 'react-i18next'
import { BsArrowLeft } from 'react-icons/bs';
import { SettlementContext } from '../settlementContext'

function BankDetails({ t, settlement_bank, }) {

  const { edit, setEdit } = useContext(SettlementContext)

  const fields = [
    {
      label: t('settings.bank_settlement.name'),
      value: settlement_bank?.bank_name ?? t('misc.na')
    },
    {
      label: t('settings.bank_settlement.acc.label'),
      value: settlement_bank?.account_name ?? t('misc.na')
    },
    {
      label: t('settings.bank_settlement.num'),
      value: settlement_bank?.account_number ?? t('misc.na')
    }
  ]

  return (
    <>
      <div className={`w-[100%] flex flex-col items-end mb-3  ${!edit.editState ? 'hidden' : ''}`}>
        <Button variant='contained' className='bg-primary ' onClick={() => setEdit({ ...edit, editState: !edit.editState })}>
          <BsArrowLeft />     Back
        </Button>
      </div>
      <section className={`w-full bg-white p-8 rounded-xl mb-5 shadow-sm  ${!edit.editState ? 'hidden' : ''}`}>

        <div className="mb-5">
          <HeaderComponent
            title="Settlement bank"
            btnText={t('settings.bank_settlement.edit')}
          // btnText={`${settlement_bank?.data ? t('settings.bank_settlement.edit') : t('settings.bank_settlement.add')}`} 
          // btnClick={settlement}
          />
        </div>

        {
          !settlement_bank || (settlement_bank && JSON.stringify(settlement_bank) === '{}') ? (
            <div className="w-full h-80 flex flex-col items-center justify-center">
              <div className="w-24 h-24 flex justify-center mb-7 items-center rounded-full bg-border-lines">
                <img src={images.Bank} alt="" className="" />
              </div>

              <p className="text-placeholder w-3/4 mx-auto text-center">{t('settings.bank_settlement.empty_info')}</p>
            </div>
          ) : (
            <ul className={`w-full`}>
              {
                fields.map(({ label, value }) => {
                  return (
                    <li className="mb-8" key={label}>
                      <label className="text-secondary text-sm">{label}</label>
                      <p className="text-dark-blue font-medium">{value}</p>
                    </li>
                  )
                })
              }
            </ul>
          )
        }
      </section>
    </>
  )
}

export default withTranslation()(BankDetails);